module.exports = __webpack_public_path__ + "static/media/Eyebrows_green.077e397d.svg";